import { Skeleton } from '~/chords/Skeleton';

export function TableCellDefaultSkeleton() {
  return (
    <div className="w-2xl">
      <Skeleton />
    </div>
  );
}

TableCellDefaultSkeleton.displayName = 'TableCellDefaultSkeleton';
